import { motion } from 'motion/react';

import { MessagesList } from './MessagesList/MessagesList';
import { Prize } from './Prize/Prize';

import styles from './Randomizer.module.css';

export const Randomizer = ({
  messages,
  currentState,
  winId,
  speed,
  messagesRef,
  questionImgUrl,
  RND_ONE_WIN,
  RND_WIN,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
      className={styles.rndWrapper}
    >
      <Prize questionImgUrl={questionImgUrl} />
      <MessagesList
        winId={winId}
        messages={messages}
        currentState={currentState}
        speed={speed || 0}
        messagesRef={messagesRef}
        RND_ONE_WIN={RND_ONE_WIN}
        RND_WIN={RND_WIN}
      />
    </motion.div>
  );
};
